<template>
  <v-container>
    <v-row class="ma-0" no-gutters>
      <div>
        <v-app-bar
          class="background"
          :class="{ 'scrolled': isScrolled || isHovered }"
          height="60"
          @mouseover="isHovered = true"
          @mouseleave="isHovered = false"
          style="
              position: absolute;
              top: 0;
              z-index: 1000;
              box-shadow: none !important;"
        >
<!--          <v-app-bar-nav-icon v-if="isMobile" @click.stop="showDrawer = !showDrawer" />-->
<!--          <v-row class="ma-0" :class="hideHeaderAndFooter ? '' : 'd-none'">-->

<!--            <v-img-->
<!--              :src="partnerGroupDetails.Logo"-->
<!--              class="ma-0"-->
<!--              alt="theDrivingForce"-->
<!--              style="cursor: pointer"-->
<!--              contain-->
<!--              position="center center"-->
<!--              height="45"-->
<!--              width="45"-->
<!--              @click="goHome"-->
<!--            />-->
<!--          </v-row>-->
          <v-row
            justify="center"
            align="center"
            :class="hideHeaderAndFooter ? 'd-none' : ''"
            class="flex-nowrap ma-0"
          >
            <v-img
              :src="partnerGroupDetails.Logo"
              class="ma-0 mr-1"
              alt="theDrivingForce"
              style="cursor: pointer"
              contain
              position="left center"
              height="40"
              width="40"
              @click="goHome"
            />

            <v-btn
              class="mx-2 px-1 text-body-1"
              :class="{ 'primary-font-color': isTransparent }"
              :color="isTransparent ? '' : 'primary'"
              text
              @click="toggleDrawer"
            >
              <v-icon size="30">menu</v-icon>
            </v-btn>
            <NavigationDrawer v-model="showDrawer" />
            <Search :isTransparent="isTransparent"/>

            <v-spacer class="hidden-md-and-down" />

            <template v-if="!isMobile">
              <HeaderThemes :isTransparent="isTransparent" />
            </template>

            <v-divider vertical light inset class="hidden-sm-and-down" />

            <HeaderTranslations :isTransparent="isTransparent" v-if="!isMobile" :isMobile="isMobile" />

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="onAccountBtnClick"
                  v-bind="attrs"
                  v-on="on"
                  :class="{ 'primary-font-color': isTransparent }"
                  :color="isTransparent ? '' : 'primary'"
                >
                  <v-icon>mdi-account</v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('ACCOUNT_TITLE') }}</span>
            </v-tooltip>

            <shopping-cart :isTransparent="isTransparent"/>

            <div v-if="userLoggedIn">
              <shopping-list :isTransparent="isTransparent"/>
            </div>
          </v-row>

          <v-dialog v-model="alertBeforeLogout" width="500" persistent>
            <v-card>
              <v-alert icon="ti-alert" type="warning">
                {{ $translate('SHOPPINGCART_NOT_EMPTY') }}
              </v-alert>
              <v-card-text>
                {{ $translate('SHOPPINGCART_NOT_EMPTY_DESCRIPTION') }}
              </v-card-text>
              <v-divider />
              <ShoppingCartList />
              <v-divider />
              <v-card-text class="font-weight-black mt-4">
                {{ $translate('SHOPPINGCART_SURE_ABOUT_LOGGING_OUT') }}
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="secondary"
                  text
                  depressed
                  @click="alertBeforeLogout = false"
                >
                  {{ $translate('CANCEL') }}
                </v-btn>
                <v-btn color="primary" depressed @click="acceptLogout">
                  {{ $translate('USER_WANT_LOGOUT') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-app-bar>
      </div>
      <v-col>
        <PromotionsViewPromotions :loading="loadingPromotions" :promotions="promotions" />
        <Benefits :isLuxuryView="true" />

        <v-row class="ma-0 px-2" justify="center">
          <v-col cols="12" md="10">
            <v-row no-gutters>
              <v-col cols="12" :order="productFocused ? 1 : 3">
                <div id="allCategories">
                  <AllCategories :wrap="true" />
                </div>
              </v-col>
              <v-col class="mt-14" cols="12" order="2">
                <TrendingProducts v-if="productFocused" />
                <TrendingEvents v-else />
              </v-col>
            </v-row>
            <ActivityCalendar />
            <Reviews />
            <BlogEvents />
            <AppDownloadButtons class="mt-14" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import homePageMixin from '@/mixins/homePage';
import StaticBannerWithCurvedCard from '@/components/homepage/StaticBannerWithCurvedCard';
import Benefits from '@/components/homepage/Benefits';
import Promotions from '@/components/homepage/Promotions';
import PromotionsViewPromotions from '@/components/homepage/PromotionsViewPromotions';
import AllCategories from '@/components/homepage/AllCategories.vue';
import ActivityCalendar from '@/components/homepage/ActivityCalendar.vue';
import BlogEvents from '@/components/homepage/BlogEvents';
import Reviews from '@/components/homepage/Reviews.vue';
import AppDownloadButtons from '@/components/homepage/appDownload/AppDownloadButtons.vue';
import uiHelpers from '@/shared/ui_helpers';
import UserJS from '@/objects/UserObject';
import HeaderThemes from '@/components/generalComponents/header/HeaderThemes';
import ShoppingCart from '@/components/generalComponents/header/ShoppingCart.vue';
import ShoppingCartList from '@/components/generalComponents/header/ShoppingCartList.vue';
import Search from '@/components/generalComponents/header/Search.vue';
import ShoppingList from '@/components/generalComponents/header/ShoppingList.vue';
import HeaderTranslations from '@/components/generalComponents/header/HeaderTranslations.vue';
import NavigationDrawer from '@/components/generalComponents/NavigationDrawer';
export default {
  name: 'PromotionsView',
  mixins: [homePageMixin][uiHelpers],
  components: {
    StaticBannerWithCurvedCard,
    Benefits,
    Promotions,
    PromotionsViewPromotions,
    AllCategories,
    ActivityCalendar,
    BlogEvents,
    Reviews,
    AppDownloadButtons,
    ShoppingCart,
    Search,
    ShoppingCartList,
    ShoppingList,
    HeaderTranslations,
    HeaderThemes,
    NavigationDrawer,
    TrendingProducts: () =>
      import('@/components/homepage/trendingProducts/TrendingProducts.vue'),
    TrendingEvents: () =>
      import('@/components/homepage/trendingEvents/TrendingEvents.vue'),
  },
  computed: {
    isTransparent() {
      return !this.isScrolled && !this.isHovered;
    },
    partnerGroupDetails() {
      const details = this.$store.getters['Account/partnerGroupDetails'];
      if (details == null) {
        return {};
      }
      return details;
    },
    hideHeaderAndFooter() {
      return this.$store.getters.getHideHeaderAndFooter;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
  },
  created() {
    window.EventBus.listen('showLogoutAlert', this.showLogoutAlert);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.EventBus.removeListener('showLogoutAlert', this.showLogoutAlert);
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      loadingPromotions: false,
      promotions: [],
      productFocused: false,
      alertBeforeLogout: false,
      isScrolled: false,
      isHovered: false,
      showDrawer: false,
    };
  },
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    handleScroll() {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (scrollPosition > 0) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
    acceptLogout() {
      this.alertBeforeLogout = false;
      this.logOut();
    },
    showLogoutAlert() {
      this.alertBeforeLogout = true;
    },
    goHome() {
      setTimeout(() => {
        this.$router.push({
          name: 'Homepage',
          params: {
            account_id: this.$store.getters.getRegion,
          },
        });
      }, 10);
    },
    onAccountBtnClick() {
      if (this.userLoggedIn) {
        // User logged in, navigate to account page
        this.$router.push({
          name: 'UserSettings',
          params: { myOrders: true },
        });
      } else {
        // User is not logged in
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Login',
        });
      }
    },
    logOut() {
      UserJS.logout();
      window.EventBus.fire(
        'activateSnackBar',
        this.$translate('SUCCESS_LOGGED_OUT')
      );

      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    // onAboutUsClick() {
    //   this.$router.push({ name: 'AboutUs' });
    // },
  },
};
</script>
<style>
.background {
  background-color: transparent !important;
}

.background:hover {
  background-color: rgb(245, 245, 245) !important;
}
.scrolled{
  background-color: rgb(245, 245, 245) !important;
  position: fixed !important;
}
</style>
